import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Settings from './pages/Settings';
import KnowledgeBase from './pages/KnowledgeBase';
import TopicsPlanner from './pages/TopicsPlanner';
import ScriptReview from './pages/ScriptReview';
import VideoReview from './pages/VideoReview';
import HeyGenLibrary from './pages/HeyGenLibrary';
import Calendar from './pages/Calendar';
import Analytics from './pages/Analytics';
import HookLibrary from './pages/HookLibrary';
import Onboarding from './pages/Onboarding';
import UserGuide from './pages/UserGuide';
import { useAuthStore } from './stores/auth.store';

function RequireAuth({ children }: { children: JSX.Element }) {
  const token = useAuthStore((s) => s.token);
  if (!token) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/settings"
        element={
          <RequireAuth>
            <Settings />
          </RequireAuth>
        }
      />
      <Route
        path="/knowledge"
        element={
          <RequireAuth>
            <KnowledgeBase />
          </RequireAuth>
        }
      />
      <Route
        path="/topics"
        element={
          <RequireAuth>
            <TopicsPlanner />
          </RequireAuth>
        }
      />
      <Route
        path="/scripts"
        element={
          <RequireAuth>
            <ScriptReview />
          </RequireAuth>
        }
      />
      <Route
        path="/videos"
        element={
          <RequireAuth>
            <VideoReview />
          </RequireAuth>
        }
      />
      <Route
        path="/heygen-library"
        element={
          <RequireAuth>
            <HeyGenLibrary />
          </RequireAuth>
        }
      />
      <Route
        path="/calendar"
        element={
          <RequireAuth>
            <Calendar />
          </RequireAuth>
        }
      />
      <Route
        path="/analytics"
        element={
          <RequireAuth>
            <Analytics />
          </RequireAuth>
        }
      />
      <Route
        path="/hooks"
        element={
          <RequireAuth>
            <HookLibrary />
          </RequireAuth>
        }
      />
      <Route
        path="/onboarding"
        element={
          <RequireAuth>
            <Onboarding />
          </RequireAuth>
        }
      />
      <Route
        path="/guide"
        element={
          <RequireAuth>
            <UserGuide />
          </RequireAuth>
        }
      />
      <Route path="*" element={<Navigate to="/onboarding" replace />} />
    </Routes>
  );
}
